export default {
      id: "oc-access-credentials-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-access-credentials",
      toString: function () {
        return this.url;
      }
    }